import type { ChatAttachment, ChatContext, PageRef } from '@shared/api';

export interface QueuedChatRequest {
  userId: string;
  message: string;
  attachments?: ChatAttachment[];
  context: ChatContext | undefined;
  contextLabel: string | null;
  /** The page the rep was viewing when they sent this — the queued row's chip (message-bar §2). Null when nothing was open. */
  page: PageRef | null;
  /** simplify.md §6: set on the `[decision] …` follow-up ComposerDock.tsx sends after the assumptions-strip's Change resolves a decision through /mutations — lets the server attach the §7a-shaped note (decisionId, not the label text). */
  decisionId?: string;
}
export function queuedContextLabel(contextLabel: string | null): string { return contextLabel ? `${contextLabel} · Queued` : 'Queued'; }
export function activeContextLabel(request: QueuedChatRequest): string | null { return request.contextLabel; }
